"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultIssueTypes = exports.DefaultIssueTypeKeys = exports.IssueType = void 0;
class IssueType {
    // eslint-disable-next-line max-params
    constructor(key, title, requirements = []) {
        this.key = key;
        this.title = title;
        this.requirements = requirements;
    }
}
exports.IssueType = IssueType;
exports.default = IssueType;
// eslint-disable-next-line no-shadow
var DefaultIssueTypeKeys;
(function (DefaultIssueTypeKeys) {
    DefaultIssueTypeKeys["UNSPECIFIED"] = "unspecified";
    DefaultIssueTypeKeys["OPERATIONAL"] = "operational";
    DefaultIssueTypeKeys["MAINTENANCE"] = "maintenance";
    DefaultIssueTypeKeys["CLEANING"] = "cleaning";
    DefaultIssueTypeKeys["FOOD"] = "food";
    DefaultIssueTypeKeys["HEALTH_SAFETY"] = "health";
})(DefaultIssueTypeKeys = exports.DefaultIssueTypeKeys || (exports.DefaultIssueTypeKeys = {}));
exports.DefaultIssueTypes = [
    new IssueType(DefaultIssueTypeKeys.UNSPECIFIED, 'Unspecified'),
    new IssueType(DefaultIssueTypeKeys.OPERATIONAL, 'Operational'),
    new IssueType(DefaultIssueTypeKeys.MAINTENANCE, 'Maintenance'),
    new IssueType(DefaultIssueTypeKeys.CLEANING, 'Cleaning'),
    new IssueType(DefaultIssueTypeKeys.FOOD, 'Food Safety'),
    new IssueType(DefaultIssueTypeKeys.HEALTH_SAFETY, 'Health and Safety'),
];
